import { render } from "./CategoryNav.vue?vue&type=template&id=2ae5e7bb&scoped=true"
import script from "./CategoryNav.vue?vue&type=script&lang=js"
export * from "./CategoryNav.vue?vue&type=script&lang=js"

import "./CategoryNav.vue?vue&type=style&index=0&id=2ae5e7bb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ae5e7bb"]])

export default __exports__